const TASKS_PER_PAGE = {
  default: 12,
  mobile: 4,
};

const INVOICES_PER_PAGE = {
  default: 12,
  mobile: 4,
};

export { TASKS_PER_PAGE, INVOICES_PER_PAGE };
